import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getPaymentTermsState = (state: AppState) => state.paymentTerms;

export const paymentTermsRequestingSelector = createSelector(getPaymentTermsState, state => state.requesting);
export const paymentTermsSelector = createSelector(getPaymentTermsState, state => state.paymentTerms);
